import {Panes, Select, TextField} from '@management-ui/core';
import {InputAdornment} from '@mui/material';
import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {ServiceContext} from '../../../../components/Services';
import YesNoField from '../../../../components/YesNoField';
import {currencySymbol} from '../../../../utilities';

const Transport = ({order = {}, prefix = ''}) => {
  const services = useContext(ServiceContext);
  const [transporters, setTransporters] = useState([]);
  const optionsLoaded = useRef(false);

  useEffect(() => {
    if (!optionsLoaded.current) {
      optionsLoaded.current = true;
      services.contact.getCachedTransporters().then((list) => {
        setTransporters(list.data.map(({id, name}) => ({title: name, value: id})));
      }).catch(() => null);
    }
  }, [services]);

  const handleReset = useCallback((subject) => {
    if (subject.transporter) {
      subject.transporter_id = `${subject.transporter.id}`;
    }
    return subject;
  }, []);

  return (
    <Panes
      entity={order}
      prefix={prefix}
      onReset={handleReset}
      panes={[
        {
          title: 'Transport',
          fields: [
            <Select
              name="transporter_id"
              prefix={prefix}
              label="Transport Company"
              options={transporters}
            />,
            <TextField
              name="transport_cost"
              prefix={prefix}
              label="Cost"
              fieldProps={{
                InputProps: {
                  startAdornment: (
                    <InputAdornment position="start">
                      {currencySymbol(order.currency)}
                    </InputAdornment>
                  )
                }
              }}
            />,
            <YesNoField
              name="transport_booked"
              prefix={prefix}
              label="Is the transport booked?"
            />
          ]
        },
        {
          title: '',
          fields: []
        }
      ]}
      title=""/>
  );
};

Transport.onSave = ({transporter_id, transport_cost, transport_booked}) => ({
  transporter_id,
  transport_cost,
  transport_booked
});

export default Transport;
